/**
Author - Babajan
Github - https://www.github.com/babajanpatan/
**/

import React from "react";
import PropTypes from "prop-types";

import CardDetails from "./CardDetails";

const propTypes = {
  formData: PropTypes.object.isRequired,
  indianCityList: PropTypes.array.isRequired,
  isUpdatingAnswer: PropTypes.bool.isRequired,
  question: PropTypes.array.isRequired,
  questionTitle: PropTypes.string.isRequired,
  setFormData: PropTypes.func.isRequired,
  setIsUpdatingAnswer: PropTypes.func.isRequired
};

const CardDetailsContainer = ({
  formData,
  indianCityList,
  isUpdatingAnswer,
  question,
  setFormData,
  questionTitle,
  setIsUpdatingAnswer
}) => {
  const selectedOption = formData[question.externalId]?.displayTitle;
  const isSelectCityRequired = question.question.qtype.includes("city");
  const isARNinput = question.question.qtype.startsWith("arn");
  const alreadySelectedAnswer = question?.selectedOptions;
  const isCustomAnswerRequired = question?.options?.length === 0;

  if (!alreadySelectedAnswer) {
    setIsUpdatingAnswer(false);
  }

  const onSelectedCityClick = (selectedCity) => {
    if (selectedCity.length > 0) {
      setFormData({
        ...formData,
        [question.externalId]: {
          answer: "",
          qnaStage: question.externalId,
          customAnswer: selectedCity
        }
      });
    }
  };

  return (
    <CardDetails
      formData={formData}
      indianCityList={indianCityList}
      isARNinput={isARNinput}
      isCustomAnswerRequired={isCustomAnswerRequired}
      isSelectCityRequired={isSelectCityRequired}
      isUpdatingAnswer={isUpdatingAnswer}
      question={question}
      questionTitle={questionTitle}
      selectedOption={selectedOption}
      setFormData={setFormData}
      onSelectedCityClick={onSelectedCityClick}
    />

  );
};

CardDetailsContainer.propTypes = propTypes;

export default CardDetailsContainer;
